module.exports = __webpack_public_path__ + "RentGuaranteeLeases-36EHKhP.svg";